import type { RouteObject } from 'react-router-dom'
import { createMemoryRouter } from 'react-router-dom'

import App from './App'
import { IntroView } from './IntroView'
import { Player } from './Player'
import { PlayerView } from './PlayerView'
import { NotFoundFullpage } from './errors/NotFound'

import { PlayerError } from 'components/PlayerError'

const routes: RouteObject[] = [
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '/',
        element: <IntroView />,
      },

      {
        path: '/player',
        element: <PlayerView />,
        children: [
          {
            path: 'active',
            index: true,
            element: <Player />,
          },
          {
            path: 'error',
            element: <PlayerError />,
          },
        ],
      },
      {
        path: '*',
        element: <NotFoundFullpage />,
      },
    ],
  },
]

export const router = createMemoryRouter(routes)
